import appmaker from '@appmaker/core/index';
import { ChartBarIcon } from '@heroicons/react/solid';
import Home from './routes/Home';

const PAnalyze = {
	id: '@appmaker/plobal-analyze',
	name: 'Analytics',
	activate: () => {
		appmaker.registerRoute({
			routeName: '/p-analyze',
			component: Home,
		});
		appmaker.registerSideBarMenu({
			name: 'Analyze',
			routeName: '/p-analyze',
			icon: ChartBarIcon,
		});
	},
};

export default PAnalyze;
